module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/command-center-lvl1-50.7a25525b.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/command-center-lvl1-50.png
// module id = 3515
// module chunks = 11